export default {
    title_list: 'Payments',
    title_page: 'Payment',
    title_create_page: 'Create payment',
    title_edit_page: 'Change payment',

    filter: {
        labels: {
            user_id: 'User',
            subscribe_id: 'Membership',
            braintree_id: 'Braintree ID',
        }
    },

    table: {
        labels: {
            id: 'ID',
            user_id: 'User',
            subscribe_id: 'Type payment',
            braintree_id: 'Braintree ID',
            cost: 'Cost',
        }
    },

    buttons: {

    },

    form: {
        user_id: 'User',
        subscribe_id: 'Membership',
        gift_id: 'Gift',
        concierge_id: 'Concierge service',
        artipro_membership_id: 'ARTIPro Membership',
        braintree_id: 'Braintree ID',
        cost: 'Cost',
        card_mask: 'Card',
        card_type: 'Card type',
    },
}
